import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormularioCadastro from './cadastro/FormularioCadastro';


ReactDOM.render(<FormularioCadastro />, document.getElementById('reactroot'));


